<template>
	<div class="page-wrapper v-cloak">
        <div class="page-grid-wrapper">    
            <div class="page-grid-fix">
                <div class="space-helper"></div>     
                    <h2>Carefully curated</h2>
                    <h4 style="width: 400px;">{{ siteSettings.other_watches_lead }}</h4>
<!-- FILTERS AND SEARCH -->
<div class="search-and-filters">
                    <div class="fs-toggles">
                        <div @click="toggleSearch" class="search-toggle-btn search-icon">
                            <img v-if="searchedWatches.length > 0" class="center" src="/images/icons/loupe-gold.svg">
                            <img v-else class="center" src="/images/icons/loupe-blk.svg">
                        </div>
                        <div @click="toggleFilters" class="filters-toggle-btn filter-icon">
                            <img v-if="filtersActive" class="center" src="/images/icons/filters-active.svg">
                            <img v-else class="center" src="/images/icons/filters-blk.svg">
                        </div>
                    </div>
    <!-- SEARCH -->
                    <div :class="['search-tray', { 'open': showSearch }]">

                        <SearchComponent 
                            :items="watches" 
                            :showSearch="showSearch"
                            @search-results="handleSearchResults"
                            @closeSearch="showSearch = false"
                        />
                        <a class="close-search" @click="toggleSearch">Close</a>
                        <!-- Search count tip -->
                        <div v-if="searchedWatches.length" :class="['search-count', { alert: searchedWatches.length === 0 }]">{{ searchedWatches.length }} watch{{ searchedWatches.length === 1 ? '' : 'es' }} match{{ searchedWatches.length === 1 ? 'es' : '' }} your criteria.</div>
                        <!-- <div v-else class="search-count ">Start typing desired watch details</div> --><!--Shown when no search activated yet or no results-->
                        
                        <div v-if="searchedWatches.length > 0" class="list-grid-toggle view-icon" @click="toggleView">
                            <img v-if="gridView" class="center" src="/images/icons/list-view-icon.svg">
                            <img v-else class="center" src="/images/icons/grid-view-icon.svg">
                        </div>

                        <div class="search-results">

                            <div v-if="gridView" class="grid-view">
                                <span v-for="watch in searchedWatches" :key="watch.SKU">
                                    <router-link :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">
                                        <figure class="image-container">
                                            <img class="imageGridSource" :src="imageGridSource(watch)" @error="handleImagePlaceholder" alt="" :key="watch.SKU">
                                            <figcaption>
                                            <span>{{ watch.Model }}</span><br>
                                            <span>Available in {{ watch.WatchLocation }}</span>
                                            </figcaption>
                                        </figure>
                                    </router-link>
                                </span>
                            </div>

                            <ul v-else  class="list-view">
                                <li v-for="watch in searchedWatches" :key="watch.SKU">
                                    <div class="search-list-container">
                                        <figure class="image-container">
                                            <img loading="lazy" class="imageGridSource" :src="imageGridSource(watch)" @error="handleImagePlaceholder" alt="" :key="watch.SKU">
                                            <figcaption>

                                                <router-link :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">

                                                    <h4>{{ watch.ManufacturerName }} {{ watch.Model }} </h4>
                                                </router-link>
                                                <p>Material: {{ watch.Material }}</p>
                                                <p>Year: {{ watch.Year }}</p>
                                                <p v-if="watch.StatusName === 'Sold'">Sold</p>
                                                <p v-if="watch.StatusName === null">In Stock</p>
                                                <p v-if="watch.StatusName === 'on hold'">In Stock</p>
                                                <p v-if="watch.StatusName === 'deposit'">On Deposit</p>
                                                <p v-else >{{ watch.StatusName }}&nbsp;&nbsp;|&nbsp;
                                                   <span v-if="watch.isPOA" class="price">POA</span>
                                                    <span v-else class="price">{{ watch.currencySymbol }} {{ watch.displayPrice }}</span>
                                                    </p>
                                                <p class="appointment-at-location"><strong>Available</strong> for appointments at our <router-link  :to="{ path: '/locations', query: { location: watch.WatchLocation }}">
                                                    {{ watch.WatchLocation }}</router-link> boutique</p>
                                            </figcaption>
                                            <!-- Button to open the pop-up -->
                                            <button @click="openPopup(watch.SKU)">Enquire Now</button>
                                        </figure>
                                    </div>

                                    <!-- Popup Overlay -->
                                    <div v-if="activePopup === watch.SKU" class="popup-overlay" @click.self="closePopup">
                                        <div class="popup">
                                            <a class="close-btn" @click="closePopup">Close</a><br>
                                            <h4>Enquiry about {{ watch.ManufacturerName }} {{ watch.Model }} </h4>
                                            <EnquiryForm :Model="watch.Model" :SKU="watch.SKU" formOrigin="Richard Mille - Search" />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        </div>     
                <!-- FILTERS TRAY -->
                        <div :class="['filters-tray', { open: showFilters }]">
                            <FiltersComponent
                            ref="filtersComponent"
                            :filterOptions="dynamicFilters"
                            :filterCount="filteredWatches.length"
                            @filters-active="handleFiltersActive"
                            @filter-changed="handleFilterChange"
                            @close-filters="toggleFilters"
                            />
                        </div>
                    </div>

                <div v-if="this.filtersActive && !this.showFilters" class="filters-applied"> ACTIVE FILTERS 
                    <br><span>{{ displayAppliedFilters }}</span><br>
                    <span  v-if="this.filtersActive && !this.showFilters" class="buttons-inline">
                         <button @click="passResetFilters">Clear Filters</button> <button @click="toggleFilters" class="filters-toggle-btn filter-icon">Refine Filters</button>
                    </span>
                </div>
<!-- END of FILTERS AND SEARCH -->
                <div  v-for="(watches, index) in allWatches" :key="index">
                    <div class="watches">
                        <div class="grid-view array-chunk">
                            <div v-for="watch in watches" :key="watch.SKU" class="grid-item watch__card" ref="card" >
                                <div class="watch__card-content">
                                    <router-link :to="{ name: 'otherwatch', params: {  watchManufacturerName: watch.ManufacturerName.split(' ').join('-'), watchSKU: watch.SKU, watchModel: watch.HTMLSafeModel.split(' ').join('') } }">
                                        <figure class="image-container">
                                            <img loading="lazy" class="imageGridSource" :src="imageGridSource(watch)" @error="handleImagePlaceholder" alt="" :key="watch.SKU">
                                            <figcaption>
                                                <p>{{ watch.ManufacturerName }} {{ watch.Model }}</p>
                                            </figcaption>
                                            <figcaption>
                                            <span v-if="watch.StatusName === 'Sold'">Sold</span>
                                            <span v-if="watch.StatusName === null" class="status">In Stock</span>
                                            <span v-if="watch.StatusName === 'on hold'" class="status">In Stock</span>
                                            <span v-if="watch.StatusName === 'deposit'" class="status">On Deposit</span>
                                            <span v-else class="status">{{ watch.StatusName }}&nbsp;&nbsp;|&nbsp;
                                                <span v-if="watch.isPOA" class="price">POA</span>
                                                    <span v-else class="price">{{ watch.currencySymbol }} {{ watch.displayPrice }}
                                                        <br>
                                                    <span class="exc-taxes" v-if="watch.MarginScheme == '1'">&nbsp;exc.&ensp;taxes </span>
                                                </span>
                                            </span>
                                            <div class="learn-more">
                                                
                                                View <img class="center" src="/images/icons/ArrowRight.svg">
                                                
                                            </div>
                                        </figcaption>

                                        </figure>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- FEATURED WATCHES SELECTED IN FEATURED WATCHES TAB IN CMS -->
                    <div class="featured-watches" v-if="index == 0 || index == 1 || index == 2 || index == 3">
                        <FeaturedWatches :loop="index" :route="showRoute"></FeaturedWatches>
                    </div>
                </div>
            </div>
        </div>	

<!-- SOLD WATCHES -->		             
        <div class="page-grid-wrapper sold-watches-grid">    
            <div class="page-grid-fix">
                <h2 style="padding: 25px 0; width: 100%; text-align: center;">Recently sold</h2>
                <div class="grid-view">
                    <div v-for="watchsold in watchessold" :key="watchsold.SKU" class="grid-item watch__card" ref="card" >
                        <div class="watch__card-content">
                            <router-link :to="{ name: 'otherwatch', params: {  watchManufacturerName: watchsold.ManufacturerName.split(' ').join('-'), watchSKU: watchsold.SKU, watchModel: watchsold.HTMLSafeModel.split(' ').join('') } }">
                            <figure>
                                <img loading="lazy" class="watch-image" :src="imageGridSource(watchsold)" alt="" @error="noPngInSold($event, watchsold)" :key="watchsold.SKU">
                                <!--<img class="watch-image" :src="'/watches/gallery/NW-' + watchsold.SKU + '/grid-image/' + 'grid_NW-' + watchsold.SKU + '.jpg'" alt="" :key="watchsold.SKU"> -->
                                <figcaption>
                                    <p>{{ watchsold.Name }}</p>
                                </figcaption>
                                <figcaption>
                                    <span class="status">Sold</span>
                                </figcaption>
                            </figure>
                            </router-link>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
<!-- END - Sold watches -->

	</div>
</template>


<script>
import ContactForm from '../components/ContactForm.vue';
import FeaturedWatches from '../components/FeaturedWatches.vue'; 
import EnquiryForm from '../components/EnquiryForm.vue';
import FiltersComponent from '../components/FiltersComponent.vue';
import SearchComponent from '../components/SearchComponent.vue';
import axios from 'axios';
import _ from 'lodash';

export default {
  name: 'OtherWatchesRandom',
  components: { ContactForm, EnquiryForm, FeaturedWatches, FiltersComponent, SearchComponent },
  props: ['featured_other', 'siteSettings'],
  data() {
    return {
      watches: [],
      watchessold: [],
      filteredWatches: [],
      searchedWatches: [],
      dynamicFilters: {},
      appliedFilters: {},
      showSearch: false,
      showFilters: false,
      filtersActive: false,
      gridView: false,
      activePopup: null,
      showRoute: this.$route.name,
      watchesRandomCancelToken: null,
      watchesSoldCancelToken: null,
      delayForm: false,
      routeChangeTimeout: null
    };
  },
  mounted() {
    this.getWatchesRandom();
    this.getWatchesSold();
    setTimeout(() => this.delayForm = true, 2000);
  },
  watch: {
    '$route.name'(newName) {
      this.showRoute = newName;

      if (this.watchesRandomCancelToken) this.watchesRandomCancelToken.cancel('Route changed.');
      if (this.watchesSoldCancelToken) this.watchesSoldCancelToken.cancel('Route changed.');

      clearTimeout(this.routeChangeTimeout);
      this.routeChangeTimeout = setTimeout(() => {
        this.getWatchesRandom();
        this.getWatchesSold();
      }, 200);
    }
  },
  methods: {
    async getWatchesRandom(address) {
      if (this.watchesRandomCancelToken) this.watchesRandomCancelToken.cancel('New request or route change.');
      this.watchesRandomCancelToken = axios.CancelToken.source();
      try {
        const response = await this.$axios.get(address || '/api/otherwatches', {
          cancelToken: this.watchesRandomCancelToken.token
        });
        this.watches = this.shuffleArray(response.data.data);
        this.filteredWatches = this.watches;
        this.updateDynamicFilters();
        this.$emit("route-data-ready"); // hide loader
      } catch (err) {
        if (!axios.isCancel(err)) console.error(err);
      }
    },
    async getWatchesSold(address) {
      if (this.watchesSoldCancelToken) this.watchesSoldCancelToken.cancel('New request or route change.');
      this.watchesSoldCancelToken = axios.CancelToken.source();
      try {
        const response = await this.$axios.get(address || '/api/otherwatchessold', {
          cancelToken: this.watchesSoldCancelToken.token
        });
        this.watchessold = response.data.data;
      } catch (err) {
        if (!axios.isCancel(err)) console.error(err);
      }
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    handleSearchResults(searchResults) { this.searchedWatches = searchResults; },
    toggleFilters() { if (this.showSearch) this.showSearch = false; this.showFilters = !this.showFilters; },
    toggleSearch() { if (this.showFilters) this.showFilters = false; this.showSearch = !this.showSearch; },
    toggleView() { this.gridView = !this.gridView; },
    openPopup(sku) { this.activePopup = sku; },
    closePopup() { this.activePopup = null; },
    passResetFilters() { if (this.$refs.filtersComponent) this.$refs.filtersComponent.resetFilters(); },
    handleFiltersActive(isActive) { this.filtersActive = isActive; },
    handleFilterChange(selectedFilters) {
      this.appliedFilters = selectedFilters;
      const { locations = [], models = [], movements = [], materials = [] } = selectedFilters;
      this.filteredWatches = this.watches.filter(watch =>
        (!locations.length || locations.includes(watch.WatchLocation)) &&
        (!models.length || models.includes(watch.Model)) &&
        (!movements.length || movements.includes(watch.Movement)) &&
        (!materials.length || materials.includes(watch.WatchMaterial))
      );
    },
    updateDynamicFilters() {
      this.dynamicFilters = {
        locations: [...new Set(this.watches.map(w => w.WatchLocation))],
        models: [...new Set(this.watches.map(w => w.Model))],
        movements: this.getUniqueMovements(),
        materials: [...new Set(this.watches.map(w => w.WatchMaterial))]
      };
    },
    getUniqueMovements() {
      const set = new Set();
      this.watches.forEach(w => {
        if (w.Movement) {
          const clean = this.mapMovement(w.Movement);
          if (clean) set.add(clean);
        }
      });
      return [...set];
    },
    mapMovement(m) {
      const map = { 'Tourbillon':'Tourbillon', 'Automatic':'Automatic', 'Manual Winding':'Manual', 'Manual':'Manual', 'Quartz':'Quartz', 'Mechanical':'Manual', 'Barometer':'Barometer' };
      if (m.includes('Tourbillon')) return map['Tourbillon'];
      if (m.includes('Automatic') || m.includes('RM Automatic') || m.includes('AP Calibre')) return map['Automatic'];
      if (m.includes('Manual') || m.includes('Manual Calibre') || m.includes('Mechanical')) return map['Manual'];
      if (m.includes('Quartz')) return map['Quartz'];
      if (m.includes('Barometer')) return map['Barometer'];
      return null;
    },
    imageLoadError(e) { e.target.parentNode.removeChild(e.target); },
    handleImagePlaceholder(e) { if (e.target.dataset.fallbackApplied) return; e.target.dataset.fallbackApplied=true; e.target.src='/watches/gallery/maintenance/grid_placeholder.png'; },
    imageGridSource(w) { return `/watches/gallery/NW-${w.SKU}/grid-image/grid_NW-${w.SKU}.png`; },
    alternativeImageGridSource(w) { return `/watches/gallery/NW-${w.SKU}/grid-image/custom_grid_image_NW-${w.SKU}.jpg`; },
    noPngInSold(e,w) { if(e.target.dataset.fallbackApplied) return; e.target.dataset.fallbackApplied=true; e.target.src=`/watches/gallery/NW-${w.SKU}/grid-image/grid_NW-${w.SKU}.jpg`; }
  },
  computed: {
    displayAppliedFilters() {
      return Object.values(this.appliedFilters).flat().join(' ');
    },
    allWatches() { return _.chunk(this.filteredWatches, 6); },
  },
  beforeUnmount() {
    if (this.watchesRandomCancelToken) this.watchesRandomCancelToken.cancel('Component unmounted.');
    if (this.watchesSoldCancelToken) this.watchesSoldCancelToken.cancel('Component unmounted.');
    clearTimeout(this.routeChangeTimeout);
  }
};
</script>




<!-- 
<script>

import EnquiryForm from '../components/EnquiryForm.vue';
import FeaturedWatches from '../components/FeaturedWatches.vue';
import FiltersComponent from '../components/FiltersComponent.vue';
import SearchComponent from '../components/SearchComponent.vue';
import axios from 'axios';
import _ from 'lodash';

export default {
    name: 'OtherWatchesRandom',
    components: {
        EnquiryForm,
        FeaturedWatches,
        FiltersComponent,
        SearchComponent
    },
    props: ['featuredOther', 'siteSettings'],

    watch: {
        '$route.name': function () {
            this.showRoute = this.$route.name;
        },
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            images: {},
            watches: [],
            watchesSold: [],
            showRoute: {
                showRoute: this.$route.name
            },
            isLoading: true, // Add a loading state
            activePopup: null,
            dynamicFilters: {}, // Object to store dynamic filter options
            filteredWatches: [], // Array to store filtered watches
            searchedWatches: [],
            showFilters: false, // Flag to control the visibility of the filter tray
            showSearch: false,
            resetButtonTitle: 'Reset Filters', // Title for the reset button
            searchTerm: '',
            searchResults: [],
            gridView: false,
            filtersActive: false,
            appliedFilters: {}, // To store the applied filters
        };
    },

    mounted() {
        this.getWatchesRandom(); // Get all watches and images via axios for grid view
        this.getWatchesSold(); // Get sold watches and images via axios for SOLD grid view at the bottom of the page
    },

    watch: {
        '$route'(to, from) {
            this.showRoute = to.name; // Dynamically update the route name
        }
    },

    methods: {
        getWatchesRandom(address) {
            this.isLoading = true; // Set loading state
            this.$axios.get(address ? address : "/api/otherwatches")
                .then(response => {
                    this.watches = response.data.data;
                    this.watches = this.shuffleArray(this.watches); // Shuffle the watches array
                    this.updateDynamicFilters();
                    this.filteredWatches = this.watches;
                    this.isLoading = false; // Reset loading state
                    this.$emit("route-data-ready"); // tells App.vue to hide loader
                })
                .catch(error => {
                    console.error("Error fetching watches:", error);
                    this.isLoading = false; // Reset loading state on error
                    this.errorMessage = "An error occurred while fetching watches."; // Display error message
                });
        },

        getWatchesSold(address) {
            this.isLoading = true; // Set loading state
            this.$axios.get(address ? address : "/api/otherwatchessold")
                .then(response => {
                    this.watchesSold = response.data.data;
                    this.isLoading = false; // Reset loading state
                })
                .catch(error => {
                    console.error("Error fetching sold watches:", error);
                    this.isLoading = false; // Reset loading state on error
                    this.errorMessage = "An error occurred while fetching sold watches."; // Display error message
                });
        },

        updateWatches(results) {
            this.searchResults = results;
        },
        
        updateDynamicFilters() {
            this.dynamicFilters = {
                locations: [...new Set(this.watches.map(watch => watch.WatchLocation))],
                models: [...new Set(this.watches.map(watch => watch.Model))],
                movements: this.getUniqueMovements(),
                materials: [...new Set(this.watches.map(watch => watch.WatchMaterial))],
            };
        },

        getUniqueMovements() {
            const movementsSet = new Set();

            this.watches.forEach(watch => {
                const movement = watch.Movement;

                if (movement) {
                    const cleanMovement = this.mapMovement(movement);
                    if (cleanMovement) {
                        movementsSet.add(cleanMovement); // Add mapped movement to the set
                    }
                }
            });

            return [...movementsSet]; // Convert Set to Array
        },

        mapMovement(movement) {
            const movementMapping = {
                'Tourbillon': 'Tourbillon',
                'Automatic': 'Automatic',
                'Manual Winding': 'Manual',
                'Manual': 'Manual',
                'Quartz': 'Quartz',
                'Mechanical': 'Manual',
                'Barometer': 'Barometer'
            };

            if (movement.includes('Tourbillon')) return movementMapping['Tourbillon'];
            if (movement.includes('Automatic')) return movementMapping['Automatic'];
            if (movement.includes('Manual')) return movementMapping['Manual'];
            if (movement.includes('Quartz')) return movementMapping['Quartz'];
            if (movement.includes('Mechanical')) return movementMapping['Mechanical'];
            if (movement.includes('Barometer')) return movementMapping['Barometer'];

            if (movement.includes('RM Automatic') || movement.includes('AP Calibre')) {
                return movementMapping['Automatic'];
            }
            if (movement.includes('Manual Calibre')) {
                return movementMapping['Manual'];
            }

            return null;
        },

        getMovementMatch(selectedMovements, movement) {
            if (!movement) return false;

            const cleanMovement = this.mapMovement(movement);

            return selectedMovements.includes(cleanMovement); // Check if the cleaned movement is in selected movements
        },

        handleFilterChange(selectedFilters) {
            this.appliedFilters = selectedFilters;
            const locations = selectedFilters.locations || [];
            const models = selectedFilters.models || [];
            const movements = selectedFilters.movements || [];
            const materials = selectedFilters.materials || [];

            this.filteredWatches = this.watches.filter(watch => {
                const locationMatch = locations.length ? locations.includes(watch.WatchLocation) : true;
                const modelMatch = models.length ? models.includes(watch.Model) : true;
                const movementMatch = movements.length ? movements.includes(watch.Movement) : true;
                const materialMatch = materials.length ? materials.includes(watch.WatchMaterial) : true;

                return locationMatch && modelMatch && movementMatch && materialMatch; 
            });
        },

        handleFiltersActive(isActive) {
            this.filtersActive = isActive;
        },

        passResetFilters() {
            if (this.$refs.filtersComponent) {
                this.$refs.filtersComponent.resetFilters();
            } else {
                console.error("filtersComponent is undefined.");
            }
        },

        handleSearchResults(searchResults) {
            this.searchedWatches = searchResults;
        },

        toggleFilters() {
            if (this.showSearch) {
                this.showSearch = false;
            }
            this.showFilters = !this.showFilters;
        },

        toggleSearch() {
            if (this.showFilters) {
                this.showFilters = false;
            }
            this.showSearch = !this.showSearch;
        },

        toggleView() {
            this.gridView = !this.gridView;
        },

        openPopup(index) {
            this.activePopup = index; // Set the active popup to the clicked item's index
        },

        closePopup() {
            this.activePopup = null; // Close the popup
        },

        imageLoadError(event) {
            event.target.parentNode.removeChild(event.target); // Remove the image from the DOM
        },

        imageGridSource(watch) {
            return '/watches/gallery/NW-' + watch.SKU + '/grid-image/grid_NW-'  + watch.SKU + '.png';
        },
        handleImagePlaceholder(event) {
            // Set the src to the placeholder image if the original image fails to load
            event.target.src = '/watches/gallery/maintenance/grid_placeholder.png';
        },

        alternativeImageGridSource(watch) {
            return watch.SKU ? `/watches/gallery/NW-${watch.SKU}/grid-image/custom_grid_image_NW-${watch.SKU}.jpg` : '/default-image.jpg';
        },
        imageGridSourceSold(watchsold) {
            return '/watches/gallery/NW-' + watchsold.SKU + '/grid-image/grid_NW-'  + watchsold.SKU + '.png';
        },
        loadJpgInSold(watchsold) {
            return '/watches/gallery/NW-' + watchsold.SKU + '/grid-image/grid_NW-'  + watchsold.SKU + '.jpg';
        },
        noPngInSold(event, watchsold) {
            // event.target.parentNode.removeChild(event.target); // Remove the image from the DOM
            event.target.src = this.loadJpgInSold(watchsold);
        },
        shuffleArray(array) {
            const clonedArray = [...array];  // Create a shallow copy of the array
            for (let i = clonedArray.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [clonedArray[i], clonedArray[j]] = [clonedArray[j], clonedArray[i]];
            }
            return clonedArray;
        },
    },

    computed: {
        displayAppliedFilters() {
            return Object.entries(this.appliedFilters)
                .map(([key, values]) => `${values.join(' ')}`)
                .join(' ');
        },

        allWatches() {
            return _.chunk(this.filteredWatches, 6); // Using the custom chunk function
        },
    },

    // Optional: cleanup or event listener handling
    // beforeDestroy() {
    //     window.removeEventListener('resize', this.handleResize);
    // },
};
</script> -->